// src/pages/VerifyEmail.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../api";
import { useTranslation } from "react-i18next";
import { CheckCircleFilled } from "@ant-design/icons";
import { message, Typography, Spin, Divider } from "antd";
import { useSearchParams } from "react-router-dom";

const Verify = () => {
  const [token, setToken] = useState("");
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<String | null>(null);
  const [verified, setVerified] = useState<Boolean>(false);
  const [apiLoading, setApiLoading] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    handleReset();
    return () => {};
  }, [token]);

  const handleReset = () => {
    setError(null);

    if(token==null||token.length==0){
      return;
    }

    setApiLoading(true);
    fetch(`${apiUrl}/user-password/activate-email?token=${token}`, {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status == 400) {
          setError(t("auth.verify.invalidToken"));
        } else if (response.status == 401) {
          setError(t("auth.verify.invalidToken"));
        } else if (response.status == 200) {
          console.log(response);
          message.success(t("auth.verify.success"));
          setVerified(true);
          navigate("/neopaas/portal/login");
        }
        return response;
      })
      .then((res) => res)
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setApiLoading(false);
      });
  };

  useEffect(() => {
    const tokenFromUrl = searchParams.get("token");

    if (tokenFromUrl) {
      console.log("Token from URL:", tokenFromUrl);
      setToken(tokenFromUrl);
    } else {
      setError(t("auth.verify.invalidLink"));
    }
  }, [searchParams, t]);

  return (
    <div
      dir={i18n.language == "en" ? "ltr" : "rtl"}
      className={`h-screen flex items-center justify-center px-2 bg-gradient-to-tr from-neo-primary/30 to-neo-primary/0 `}
    >
      <div
        className={`bg-white p-8 shadow-sm rounded-md border-b-4 border-neo-primary/50 w-full md:w-[32rem] lg:w-[32rem] xl:w-[32rem]`}
      >
        <form>
          <div className="flex justify-between items-center">
            <Typography className="text-transparent bg-clip-text bg-gradient-to-r from-neo-primary to-neo-matt font-poppins-700 mb-4 text-3xl">
              NeoPaas
            </Typography>
          </div>
          <Divider />

          {apiLoading ? (
            <div className="flex justify-center items-center gap-x-2">
              <Typography className="font-poppins-500 text-xl mb-4">{t("auth.verify.verifying")}</Typography>
              <Spin />
            </div>
          ) : (
            <div>
              {verified ? (
                <div className="flex justify-center items-center gap-x-2">
                  <Typography className="font-poppins-500 text-xl mb-4">{t("auth.verify.verified")}</Typography>
                  <CheckCircleFilled />
                </div>
              ) : (
                <div className="h-10 ">
                  {error && <Typography className="text-red-600 font-poppins-400 text-center">{error}</Typography>}
                </div>
              )}
            </div>
          )}

          <Divider />
          <div className="flex gap-x-3 justify-end items-center "></div>
        </form>
      </div>
    </div>
  );
};

export default Verify;
